//#region Util Imports

import * as $ from 'jquery'

//#endregion

import { IReferenceType, IOpChangeState, IJsonSerializable } from '../util/interfaces'
import { Enums } from '../common/enums'
import { DataProvider } from '../../helpers/data-provider'
import { OpDescr } from './op-descr'

export class OpLocationType implements IReferenceType, IOpChangeState, IJsonSerializable {
    public idLocationType: number
    public name: string
    public idDescr: number
    public descr: OpDescr

    constructor(opObj: any) {
        this.fromJSON(opObj)
    }

    //IOpChangeState implementation
    public opState: Enums.OpChangeState
    //IOpChangeState implementation end
    //IReferenceType implementation
    public getReferenceType(): Enums.ReferenceType {
        return Enums.ReferenceType.IdLocationType
    }
    public getReferenceKey(): number {
        return this.idLocationType
    }
    public getReferenceValue(): any {
        return this
    }
    //IReferenceType implementation end
    //Custom Properties implementation
    public dynamicValues: { Key: string, Value: any }[] = []
    //Custom Properties implementation end

    public fromJSON(opObj: any, compressed: boolean = false): void {
        if (opObj) {
            if (compressed || (opObj && opObj.__IC && opObj.__IC == 1)) {
                this.idLocationType = opObj.IT
                this.name = opObj.N
                this.idDescr = opObj.I
                this.descr = opObj.D ? new OpDescr(opObj.D) : null
                this.opState = opObj.O
                this.dynamicValues = opObj.DV
            } else {
                this.idLocationType = opObj.ID_LOCATION_TYPE
                this.name = opObj.NAME
                this.idDescr = opObj.ID_DESCR
                this.descr = opObj._Descr ? new OpDescr(opObj._Descr) : null
                this.opState = opObj.OpState
                this.dynamicValues = opObj.dynamicValues
            }
        }
    }

    public toJSON(compressed: boolean = false): any {
        if (compressed) {
            return {
                IT: this.idLocationType,
                N: this.name,
                I: this.idDescr,
                D: this.descr ? this.descr.toJSON(compressed) : null,
                O: this.opState,
                DV: this.dynamicValues,
                __IC: 1
            }
        } else {
            return {
                ID_LOCATION_TYPE: this.idLocationType,
                NAME: this.name,
                ID_DESCR: this.idDescr,
                _Descr: this.descr ? this.descr.toJSON(compressed) : null,
                OpState: this.opState,
                dynamicValues: this.dynamicValues
            }
        }
    }
    
    public toString() {
        if (this.descr)
            return this.descr.description
        else
            return this.name
    }

    public static loadNavigationProperties(dataProvider: DataProvider, list: OpLocationType[]): JQueryPromise<OpLocationType[]> {
        var defered = $.Deferred<OpLocationType[]>()

        defered.resolve(list)

        return defered.promise()
    }
}